import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import FocusGroupAdmin from './components/FocusGroupAdmin';
import FocusGroupParticipants from './components/FocusGroupParticipants';
import FocusGroupFeedback from './components/FocusGroupFeedback';
import FocusGroupAnalytics from './components/FocusGroupAnalytics';
import Loading from './components/Loading';
import PDFSigner from './components/PDFSigner';
import DocumentationViewer from './components/DocumentationViewer';
import Settings from './components/Settings';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get('/api/user', { withCredentials: true });
      setUser(response.data.user);
    } catch (error) {
      console.error('Auth check failed:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-cream-100 via-white to-sage-50">
        <Routes>
          <Route 
            path="/" 
            element={user ? <Dashboard user={user} /> : <Login />} 
          />
          <Route
            path="/admin"
            element={user ? <AdminPanel user={user} /> : <Navigate to="/" />}
          />
          <Route
            path="/focus-groups"
            element={user ? <FocusGroupAdmin user={user} /> : <Navigate to="/" />}
          />
          <Route
            path="/focus-groups/participants"
            element={user ? <FocusGroupParticipants user={user} /> : <Navigate to="/" />}
          />
          <Route
            path="/focus-groups/feedback"
            element={user ? <FocusGroupFeedback user={user} /> : <Navigate to="/" />}
          />
          <Route
            path="/focus-groups/analytics"
            element={user ? <FocusGroupAnalytics user={user} /> : <Navigate to="/" />}
          />
          <Route
            path="/sign-pdf" 
            element={user ? <PDFSigner user={user} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/dev-docs" 
            element={user ? <DocumentationViewer user={user} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/settings" 
            element={user ? <Settings user={user} /> : <Navigate to="/" />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
